// removed by extract-text-webpack-plugin
module.exports = {"warningMessage":"_1PXDerQwEdvEEBo6tgwnbR","icon":"_15CS9Wj0dHdUZ_mD-rlG46"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WarningMessage/WarningMessage.scss
// module id = 1813
// module chunks = 0